module.exports = __webpack_public_path__ + "img/camera-arlo.1f4b6120.png";